// USPS Publication 28 — canonical suffix abbreviations + directional words.
// The order matters: longer/more-specific patterns first so e.g. "NORTHEAST"
// is folded before "NORTH" can match.
const RULES = [
    // Suffixes (expanded → USPS abbreviation, with optional plural).
    [/\bALLEYS?\b/gi, 'ALY'],
    [/\bAVENUES?\b/gi, 'AVE'],
    [/\bBOULEVARDS?\b/gi, 'BLVD'],
    [/\bCIRCLES?\b/gi, 'CIR'],
    [/\bCOURTS?\b/gi, 'CT'],
    [/\bCRESCENTS?\b/gi, 'CRES'],
    [/\bDRIVES?\b/gi, 'DR'],
    [/\bEXPRESSWAYS?\b/gi, 'EXPY'],
    [/\bHIGHWAYS?\b/gi, 'HWY'],
    [/\bLANES?\b/gi, 'LN'],
    [/\bPARKWAYS?\b/gi, 'PKWY'],
    [/\bPLACES?\b/gi, 'PL'],
    [/\bROADS?\b/gi, 'RD'],
    [/\bSQUARES?\b/gi, 'SQ'],
    [/\bSTREETS?\b/gi, 'ST'],
    [/\bTERRACES?\b/gi, 'TER'],
    [/\bTRAILS?\b/gi, 'TRL'],
    [/\bTURNPIKES?\b/gi, 'TPKE'],
    // Directionals — compound first so they don't get split.
    [/\bNORTHEAST\b/gi, 'NE'],
    [/\bNORTHWEST\b/gi, 'NW'],
    [/\bSOUTHEAST\b/gi, 'SE'],
    [/\bSOUTHWEST\b/gi, 'SW'],
    [/\bNORTH\b/gi, 'N'],
    [/\bSOUTH\b/gi, 'S'],
    [/\bEAST\b/gi, 'E'],
    [/\bWEST\b/gi, 'W'],
];
/**
 * A trailing unit / suite / building designator and everything after it
 * ("UNIT 2300", ", SUITE 710", "#710", "BLDG B"). Stripped so every unit of a
 * building shares one street + address key (#171: 500 W 2nd St had 201
 * permits, but only the 2 without a unit matched). Written to work in both
 * JS and BigQuery's RE2 (apps/api/src/sql/streetKey.ts), uppercase input.
 */
export const UNIT_SUFFIX = String.raw `,?\s+(UNIT|APT|APARTMENT|STE|SUITE|BLDG|BUILDING|FL|FLOOR|RM|ROOM|SPC|SPACE|LOT|#)(\s|[0-9]|$).*$`;
const UNIT_SUFFIX_RE = new RegExp(UNIT_SUFFIX);
/**
 * Fold a free-form street name to the USPS-canonical abbreviation form.
 * "Sweetwater Trail" → "SWEETWATER TRL", "North Main Street" → "N MAIN ST".
 *
 * The corresponding SQL canonicalization lives in
 * `apps/api/src/sql/streetKey.ts` so the same rules apply on both sides of
 * the comparison.
 */
export function canonicalizeStreet(s) {
    // Strip all periods (e.g. "Ave." → "Ave"), then collapse whitespace, then
    // apply the rules. The SQL counterpart in apps/api/src/sql/streetKey.ts
    // follows the same sequence — keep them in lockstep.
    let out = s.replace(/\./g, '').trim().replace(/\s+/g, ' ');
    for (const [re, to] of RULES)
        out = out.replace(re, to);
    return out.toUpperCase().replace(UNIT_SUFFIX_RE, '');
}
//# sourceMappingURL=canonicalStreet.js.map